




import Vue from 'vue';
import TableProvider from '@/api/TableProvider';
import { blowDisplayName } from '@/models/skills/blows/registry';
import type { IStateEffectTableRow } from '@vincentzhang96/dv-dnt-table-interfaces/src/duck';

export default Vue.extend({
    name: 'StateVfxChip',
    props: {
        stateEffectId: {
            type: Number as () => number,
            required: true,
        },
    },
    data() {
        return {
            effect: null as IStateEffectTableRow | null,
        };
    },
    watch: {
        stateEffectId() {
            this.load();
        },
    },
    computed: {
        chipName(): string {
            // The template always appends " #<id>", so the fallback must not repeat it.
            if (!this.effect) {
                return 'State VFX';
            }
            if (this.effect._StaticName) {
                return this.effect._StaticName;
            }
            if (this.effect._StateEffectIndex) {
                return blowDisplayName(this.effect._StateEffectIndex);
            }
            return 'State VFX';
        },
        boundBlowName(): string {
            if (this.effect && this.effect._StateEffectIndex) {
                return blowDisplayName(this.effect._StateEffectIndex);
            }
            return '';
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            this.effect = null;
            try {
                this.effect = await TableProvider.getTableRow<IStateEffectTableRow>('stateeffecttable', this.stateEffectId);
            } catch (e) {
                // keep "State VFX #id" fallback
            }
        },
    },
});
